import { render, staticRenderFns } from "./BlockPersonsRow.vue?vue&type=template&id=4a8b2970&scoped=true&"
import script from "./BlockPersonsRow.vue?vue&type=script&lang=js&"
export * from "./BlockPersonsRow.vue?vue&type=script&lang=js&"
import style0 from "./BlockPersonsRow.vue?vue&type=style&index=0&id=4a8b2970&prod&scoped=true&lang=css&"
import style1 from "./BlockPersonsRow.vue?vue&type=style&index=1&id=4a8b2970&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b2970",
  null
  
)

export default component.exports